import { render, staticRenderFns } from "./LiquidacionResumenTab.vue?vue&type=template&id=6a98a617&"
import script from "./LiquidacionResumenTab.vue?vue&type=script&lang=js&"
export * from "./LiquidacionResumenTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports